enum ETreeSortTypes {
  Id = 'id',
  Type = 'type',
  Name = 'name',
  DateCreated = 'date created',
  Owner = 'owner',
}

export default ETreeSortTypes;
